import { render } from "./MDiscount.vue?vue&type=template&id=f6093c0a&scoped=true&ts=true"
import script from "./MDiscount.vue?vue&type=script&lang=ts"
export * from "./MDiscount.vue?vue&type=script&lang=ts"

import "./MDiscount.vue?vue&type=style&index=0&id=f6093c0a&lang=scss&scoped=true"
import "./MDiscount.vue?vue&type=style&index=1&id=f6093c0a&lang=scss"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6093c0a"]])

export default __exports__